import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'scanned_in_at': 'String',
	'booking_date': '[String]',
}

export default gql(`
	query employees_confidant( ${ HelperGraphql.createFields( fields ) } ) {
		employees_confidant {
			guid
			name
			visible_for_employees
			response_employee
			confidant
			photo_url
			email
			phonenumber
			landline_phonenumber
			
			bookings( booking_date: $booking_date ) {
				guid
				kind
				booking_date
				
				building {
					guid
				}
				
				floor {
					guid
				}
				
				room {
					guid
				}
			}
			
			scans( scanned_in_at: $scanned_in_at ) {
				guid
				code
				scanned_in_at
				scanned_in_through
				scanned_out_at
				scanned_out_through
				
				building {
					guid
				}
				
				floor {
					guid
				}
				
				room {
					guid
				}
			}
		}
	}
`);

